import {
    composeGuards,
    redirectIfFeatureNotEnabled,
    redirectIfNotLoggedIn,
} from '@/app/shared/utils/router-guards/auth';

const HomeRoutes = [
    {
        name: 'SplashScreen',
        path: '/',
        component: () => import('@/app/modules/home/SplashScreen.vue'),
        beforeEnter: composeGuards(
            redirectIfFeatureNotEnabled(['venue_mode'], { name: 'Home' }),
            redirectIfNotLoggedIn
        ),
    },
    {
        name: 'Home',
        path: '/home',
        component: () => import('@/app/modules/home/Home.vue'),
        beforeEnter: redirectIfNotLoggedIn,
    },
];

export default HomeRoutes;
